import { render } from "./ConfirmImportModal.vue?vue&type=template&id=86a396ea"
import script from "./ConfirmImportModal.vue?vue&type=script&lang=js"
export * from "./ConfirmImportModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__